import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { useCustomerList } from "../../../../api/customersApi"
import { EntityListRowContent } from "../../../shared/EntityListRowContent"
import { RelBadge } from "../../../shared/RelBadge"
import { EntityPickerTable } from "./EntityPickerTable"

/** Customer multi-select picker for the Conformity → Generate flow.
 *
 *  Thin config wrapper around {@link EntityPickerTable} — see that file's
 *  docstring for why the two pickers share an implementation. Row content
 *  matches the Master Data panel: name + email + products-sold badge.
 */
export function CustomerPickerTable({
  selectedIds,
  onToggle,
}: {
  selectedIds: Set<string>
  onToggle: (id: string) => void
}) {
  const { translate } = useTranslation()
  return (
    <EntityPickerTable
      selectedIds={selectedIds}
      onToggle={onToggle}
      useList={useCustomerList}
      emptyLabelKey="MC_CS_CONF_GEN_PICKER_EMPTY_CUSTOMERS"
      entityLabelKey="MC_CS_CONF_GEN_PICKER_ENTITY_CUSTOMERS"
      renderContent={(row) => (
        <EntityListRowContent
          title={row.name}
          meta={row.email ? <span>{row.email}</span> : undefined}
          badges={
            <RelBadge
              label={translate("MC_MD_REL_LABEL_PRODUCTS")}
              labelOne={translate("MC_MD_REL_LABEL_PRODUCTS_ONE")}
              count={row.productsSoldCount}
              tone="muted"
              items={row.relProducts.map((p) => ({
                id: p.id,
                primary: p.name,
                secondary: p.status,
              }))}
            />
          }
        />
      )}
    />
  )
}
